import React, { PureComponent } from 'react';
import {
    LineChart, XAxis, YAxis, CartesianGrid,
    Tooltip, ResponsiveContainer, Line, Legend
} from 'recharts';
import './DRChart.css';
import { PrettyDate } from '../../helpers/DateHelper';

const CustomTooltip = (props) => {
    var { active, payload } = props;
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip" style={{ paddingLeft: '80px'}}>
            <span>{PrettyDate(payload[0].payload.date, 'dd/MM/yyyy')}</span>
            <span>{props.stocks[0].displayName}: {payload[0].payload.close1.toFixed(2)}</span>
            <span>{props.stocks[1].displayName}: {payload[0].payload.close2.toFixed(2)}</span>
        </div>
      );
    }
  
    return null;
  };

export default class DRChart extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            datas: [],
            isLoading: true
        };
    }

    async loadContent(url) {
        try {
            const response = await fetch(url);
            const data = await response.json();
            return data;
        }
        catch {
            console.log("Error");
            return [];
        }
    }

    async loadMarketDataChart(stocks) {
        if (stocks && stocks.length === 2) {
            var url = 'api/MarketData/GetDRDailyInfo?symbol=' + stocks[0].symbol + '&recordToTake=' + 90;
            var result1 = await this.loadContent(url);
            url = 'api/MarketData/GetDRDailyInfo?symbol=' + stocks[1].symbol + '&recordToTake=' + 90;
            var result2 = await this.loadContent(url);
            var datas = [];
            result1.forEach(obj => {
                var data = {};
                data["date"] = obj.date;
                data["close1"] = obj.close;

                const found = result2.find((obj2) => obj2.date === data["date"]);
                if(found) {
                    data["close2"] = found.close;
                    datas.push(data);
                } 
            });
            
            this.setState({ datas, isLoading: false });
        }            
    }
    

    async componentDidMount() {
        await this.loadMarketDataChart(this.props.stocks);
    }

    async componentDidUpdate(previosProps) {
        if (this.props.stocks !== "" && previosProps.stocks !== this.props.stocks) {
            await this.loadMarketDataChart(this.props.stocks);
        }         
    }

    static renderChart(data, stocks) {
        var ticks = [];
        
        if(data && data.length > 2) {
            var middleIndex = Math.floor(data.length / 2);
            var lastIndex = data.length - 1;

            ticks.push(data[1].date);
            ticks.push(data[middleIndex].date);
            ticks.push(data[lastIndex - 1].date);
        }

        return (
            <ResponsiveContainer width="100%" height="100%" id={`compare-chart`}>
                <LineChart
                    width={500}
                    height={200}
                    data={data}
                    margin={{
                        top: 20,
                        right: 0,
                        left: 0,
                        bottom: 0,
                    }}
                >
                    <CartesianGrid horizontal={true} vertical={false} stroke='rgba(0, 0, 0, 0.09)' />
                    <XAxis
                        dataKey="date"
                        axisLine={false}
                        tickLine={false}
                        style={{ fontSize: '14px' }}
                        ticks={ticks}
                        padding={{ right: 0, left: 0 }}
                        interval={0}
                        tickFormatter={tick => PrettyDate(tick)}
                    />
                    <YAxis
                        yAxisId={'left'}
                        axisLine={{ stroke: 'rgba(0, 0, 0, 0.09)' }}
                        tickSize={0.1}
                        allowDecimals={true}
                        domain={['auto', 'auto']}
                        style={{ fontSize: '14px' }}
                        dataKey='close2'
                        padding={{ bottom: 0 }}
                        tickFormatter={tick => tick.toFixed(2)}
                        dx={-20}
                        interval={'preserveStart'}
                    />
                    <YAxis
                        yAxisId={'right'}
                        orientation='right'
                        axisLine={{ stroke: 'rgba(0, 0, 0, 0.09)' }}
                        tickSize={0.1}
                        allowDecimals={true}
                        domain={['auto', 'auto']}
                        style={{ fontSize: '14px' }}
                        dataKey='close1'
                        padding={{ bottom: 0 }}
                        tickFormatter={tick => tick.toFixed(2)}
                        dx={20}
                        interval={'preserveStart'}
                        
                    />
                    <Tooltip
                        allowEscapeViewBox={{ x: false, y: false }}
                        content={<CustomTooltip stocks={stocks} />}
                        position={{ x: 0, y: 20 }}
                        dot={false}
                    />
                    <Line name={stocks[0].displayName} type="monotone" dataKey="close1" yAxisId={'right'} dot={false} stroke='#004EBA' />
                    <Line name={stocks[1].displayName} type="monotone" dataKey="close2" yAxisId={'left'}  dot={false} stroke='#EB6101' />
                    <Legend />
                </LineChart>
            </ResponsiveContainer>
        );

    }

    render() {
        if (this.state.isLoading) {
            return <p><em>Loading Chart ...</em></p>;
        } else {
            return DRChart.renderChart(this.state.datas, this.props.stocks);
        }        
    }
}
